export const weatherURL =
  'https://api.open-meteo.com/v1/forecast?latitude=52.8947&longitude=-0.7826&current=temperature_2m,weather_code,is_day,cloud_cover,wind_speed_10m&timezone=Europe%2FLondon&timeformat=unixtime';

export function parseWeather(input, now = Date.now()) {
  const c = input?.current;
  if (
    !c ||
    !['temperature_2m', 'weather_code', 'is_day', 'cloud_cover', 'wind_speed_10m', 'time'].every(
      (k) => typeof c[k] === 'number' && Number.isFinite(c[k])
    )
  ) {
    throw new Error('Incomplete weather');
  }
  const time = Number(c.time) * 1000;
  if (now - time > 90 * 60 * 1000 || time - now > 30 * 60 * 1000) throw new Error('Outdated weather');
  if (![0, 1].includes(Number(c.is_day)) || Number(c.cloud_cover) < 0 || Number(c.cloud_cover) > 100) {
    throw new Error('Invalid weather');
  }
  return {
    temperature: Number(c.temperature_2m),
    code: Number(c.weather_code),
    day: c.is_day === 1,
    cloud: Number(c.cloud_cover) / 100,
    wind: Number(c.wind_speed_10m),
    time,
  };
}

export function weatherKind(code) {
  return [71, 73, 75, 77, 85, 86].includes(code)
    ? 'snow'
    : [51, 53, 55, 56, 57, 61, 63, 65, 66, 67, 80, 81, 82, 95, 96, 99].includes(code)
      ? 'rain'
      : [45, 48].includes(code)
        ? 'fog'
        : 'dry';
}

export function weatherLabel(code, day = true) {
  if (code >= 95) return 'Thunderstorms';
  const kind = weatherKind(code);
  if (kind === 'snow') return 'Snow';
  if (kind === 'rain') return code < 60 ? 'Drizzle' : 'Rain';
  if (kind === 'fog') return 'Mist & fog';
  return code === 0
    ? day
      ? 'Clear skies'
      : 'Clear night'
    : code === 1
      ? 'Mostly clear'
      : code === 2
        ? 'Partly cloudy'
        : code === 3
          ? 'Overcast'
          : 'Local weather';
}

export function watchWeather(onChange) {
  let stopped = false;
  let busy = false;
  let lastAttempt = 0;
  let request;
  async function refresh() {
    if (stopped || busy || document.hidden) return;
    busy = true;
    lastAttempt = Date.now();
    request = new AbortController();
    const timeout = setTimeout(() => request?.abort(), 10000);
    try {
      const r = await fetch(weatherURL, { signal: request.signal });
      if (!r.ok) throw new Error('Weather unavailable');
      const data = parseWeather(await r.json());
      if (!stopped) onChange({ data, state: 'current' });
    } catch {
      if (!stopped) onChange({ data: null, state: 'unavailable' });
    } finally {
      clearTimeout(timeout);
      busy = false;
    }
  }
  const visible = () => {
    if (Date.now() - lastAttempt > 15 * 60 * 1000) void refresh();
  };
  onChange({ data: null, state: 'loading' });
  void refresh();
  const timer = setInterval(() => void refresh(), 15 * 60 * 1000);
  document.addEventListener('visibilitychange', visible);
  return () => {
    stopped = true;
    request?.abort();
    clearInterval(timer);
    document.removeEventListener('visibilitychange', visible);
  };
}
